function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_Eq448cVIBv24bq3dx7TmCWdVd7f6Xcmu"
}, /*#__PURE__*/React.createElement("rect", {
  x: 333,
  y: 177,
  width: 400,
  height: 300
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_Eq448cVIBv24bq3dx7TmCWdVd7f6Xcmu)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 733 477 L 733 177 L 333 177 L 333 477 L 358.708 477 L 498 300 L 557 370 L 580 345 L 702.757 477 L 733 477 Z ",
  fill: "rgb(235,235,235)"
}));

var SvgImgplaceholder = function SvgImgplaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "333 177 400 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgplaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imgplaceholder.8008549f.svg";
export { ForwardRef as ReactComponent };